import { EBroadcastTypes, SessionTypesEnum } from '@/types/session.types';
import { ICONS } from '@ui/icons/types';
import { TBroadcastTypePickerOptions } from './broadcast-type-picker.types';
import ProjectColorIcon from '@ui/icons/icon/project-color-icon';

const getBroadcastTypeIcon = (broadcastType: TBroadcastTypePickerOptions, size: number = 12) => {
  switch (broadcastType) {
    case EBroadcastTypes.greenroom:
      return <ProjectColorIcon name={ICONS.TELLY} size={size} />;
    case EBroadcastTypes.rtmps:
      return <ProjectColorIcon name={ICONS.RTMP} size={size} />;
    case EBroadcastTypes.embed:
      return <ProjectColorIcon name={ICONS.EMBED} size={size} />;
    case EBroadcastTypes.fireside:
      return <ProjectColorIcon name={ICONS.GOOGLE_GROUP} size={size} />;
    case SessionTypesEnum.breakoutRooms:
      return <ProjectColorIcon name={ICONS.GOOGLE_DRIVE} size={size} />;
    case SessionTypesEnum.onDemand:
      return <ProjectColorIcon name={ICONS.ON_DEMAND} size={size} />;
    default:
      return <ProjectColorIcon name={ICONS.TELLY} size={size} />;
  }
};

export default getBroadcastTypeIcon;
